/**
 * CirujanoSelect (2026-09-01 — facturación de los quirófanos de externos)
 * -----------------------------------------------------------------------
 * Selector del cirujano externo SOLO desde el catálogo de cirujanos dados
 * de alta (Catálogo QX). Sin texto libre: con él se escribía el nombre de
 * la clínica o se dejaba vacío, y el Registro de externos no podía
 * facturar. El backend valida igualmente contra el catálogo.
 */
import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export default function CirujanoSelect({ value, onChange, dataTestid }) {
  const [cirujanos, setCirujanos] = useState([]);

  useEffect(() => {
    api.get('/api/qx-catalogo', { params: { tipo: 'cirujano' } })
      .then((r) => setCirujanos(Array.isArray(r.data) ? r.data : []))
      .catch(() => setCirujanos([]));
  }, []);

  return (
    <div>
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger className="mt-1.5" data-testid={dataTestid}>
          <SelectValue placeholder="— Elige el cirujano —" />
        </SelectTrigger>
        <SelectContent>
          {cirujanos.map((c) => (
            <SelectItem key={c.id || c.nombre} value={c.nombre}>
              {c.nombre}{c.clinica ? ` · ${c.clinica}` : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-[11px] text-muted-foreground mt-1">
        Solo cirujanos dados de alta. Si falta alguno, se añade en el Catálogo QX.
      </p>
    </div>
  );
}
